import { Navigate } from "react-router-dom";
import { useAuth } from "../shared/utilities/authProvider";

const EmployeeRoute = ({ children }) => {
  const { token, loading } = useAuth();

  if (loading) return <div>Loading...</div>;

  if (!token) {
    return <Navigate to="/" replace />;
  }

  // Admin & Employee both allowed
  return children;
};

export default EmployeeRoute;